
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private ifEdit: any;
  @Prop()
  private showBtn: any;
  @Prop()
  private jianyanData: any;
  @Watch("jianyanData", { immediate: true })
  private jianyanDataChange() {
    if (this.jianyanData) {
      this.data = JSON.parse(JSON.stringify(this.jianyanData));
    } else {
      this.data = [];
    }
  }
  private data: any = [];
  private editOne(d: any) {
    let i: any = "";
    this.data.forEach((ele: any, index: any) => {
      if (ele.name == d.name) {
        i = index;
      }
    });
    const obj: any = {
      index: i,
      data: d,
    };
    this.$emit("edit", obj);
  }
  private delOne(d: any) {
    this.$confirm("您是否确定删除当前内容？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      this.data.forEach((ele: any, index: any) => {
        if (ele.name == d.name) {
          this.data.splice(index, 1);
        }
      });
      this.$emit("update", this.data);
    });
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (!this.ifEdit) {
      return false;
    }
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
  private allowDrag() {
    if (this.ifEdit) {
      return true;
    } else {
      return false;
    }
  }
  private nodeDrop() {}
}
